import SbEditable from "storyblok-react";
import config from "config/config";
import SupChat from "components/SupChat";
import WhyChooseAirHelp from "../components/WhyChooseAirHelp";
import type { DynamicComponentProps } from "./DynamicComponent.d";

// eslint-disable-next-line import/no-cycle
import {
  Button,
  Cards,
  CheckList,
  Content,
  Image,
  InfoBox,
  Subscribe,
  Table,
  CTA,
  ImageCTA,
  SideBarHeading,
  LinkBox,
  ErrorComponent,
  Column,
  Heading,
  Row,
  Link,
  LegalContent,
  BlogLegacyContent,
  Trustpilot,
  TrustpilotReviewCard,
  Anchor,
  Logo,
  Flags,
  HeroForm,
  TrustpilotSlider,
  Accordion,
  HelpQuestion,
  Spacer,
  Schema,
  ComparisonCards,
  PieChart,
  Icon,
  TextSwitcher,
  AhPlusPricingPlans,
  CompensationFeeCards,
  FeeModelCards,
  BarcodeScannerButton,
} from "../adapters/index";

const developmentEnvironment = config.buildEnv === "development";

// resolve Storyblok components to Next.js components
const Components = {
  sideBarHeading: SideBarHeading,
  heading: Heading,
  content: Content,
  ctaSection: CTA,
  ctaImageSection: ImageCTA,
  legalContent: LegalContent,
  blogLegacyContent: BlogLegacyContent,
  image: Image,
  row: Row,
  column: Column,
  link: Link,
  linkBox: LinkBox,
  infoBox: InfoBox,
  checkList: CheckList,
  table: Table,
  subscribe: Subscribe,
  cards: Cards,
  button: Button,
  trustpilotReview: TrustpilotReviewCard,
  trustpilot: Trustpilot,
  anchor: Anchor,
  logo: Logo,
  flags: Flags,
  heroForm: HeroForm,
  trustpilotSlider: TrustpilotSlider,
  supChat: SupChat,
  accordion: Accordion,
  helpQuestion: HelpQuestion,
  whyChooseAirHelp: WhyChooseAirHelp,
  spacer: Spacer,
  schema: Schema,
  comparisonCards: ComparisonCards,
  pieChart: PieChart,
  icon: Icon,
  textSwitcher: TextSwitcher,
  ahPlusPricingPlans: AhPlusPricingPlans,
  compensationFeeCards: CompensationFeeCards,
  feeModelCards: FeeModelCards,
  barcodeScannerButton: BarcodeScannerButton,
};

const DynamicComponent = ({ blok }: DynamicComponentProps) => {
  const Component = Components[blok.component] || (developmentEnvironment && ErrorComponent);
  return (
    <SbEditable content={blok}>
      <Component blok={blok} />
    </SbEditable>
  );
};

export default DynamicComponent;
